import { useEffect } from 'react'
import {
  BannerOfferSloganBlue,
  BOGO_I18N_NAMESPACE,
  BogoTermsCopy,
  HowItWorksTiles,
  trackOfferAcknowledged,
  trackOfferViewed,
  UrgencyTextGreen,
} from '@mc/bogo'
import { Badge } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { ButtonsSection } from 'pages/find-my-classes/components/Quiz/components/ButtonsSection'
import { useQuizEvents } from 'pages/find-my-classes/components/Quiz/events'
import styles from './styles.module.scss'

export const BogoOfferInterstitial = () => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)
  const { trackInterstitialScreenViewed, trackClickInterstitial } =
    useQuizEvents()

  useEffect(() => {
    trackOfferViewed('quiz_interstitial')
    trackInterstitialScreenViewed()
  }, [trackInterstitialScreenViewed])

  const onNext = () => {
    trackOfferAcknowledged('quiz_interstitial')
    trackClickInterstitial({ action: 'Next' })
  }

  return (
    <div className='row no-gutters-vertical justify-content-center'>
      <div className='col-12 d-flex flex-column align-items-center'>
        <div className='mc-mb-6'>
          <div className='d-flex flex-column align-items-center text-center mc-py-2'>
            <Badge
              className={`${styles.urgencyBadge} mc-my-7 mc-text--uppercase mc-text-x-small mc-text--bold`}
            >
              <UrgencyTextGreen />
            </Badge>
            <h2
              className={`${styles.offerHeadline} mc-my-2 mc-text--brand mc-text--uppercase mc-text--center`}
            >
              <BannerOfferSloganBlue />
            </h2>
            <BogoTermsCopy
              onTermsClick={() => {
                trackClickInterstitial({ action: t('offerTerms.label') })
              }}
            />
          </div>
          <HowItWorksTiles />
        </div>

        <div className='row no-gutters mc-w-100 justify-content-center'>
          <div className='col-12 col-lg-7'>
            <ButtonsSection onNext={onNext} />
          </div>
        </div>
      </div>
    </div>
  )
}
